import { Apprentice } from './person.model'

export enum GradeTypeCT {
  // (Teil-)Note innerhalb des Semesters
  midterm_grade = 1,
  // Komplett Note des Moduls/Fachs über das ganze Semester
  semester_grade = 2,
  // Endnote Ausbildung
  final_grade = 3,
}

export interface GradeSchema {
  grade_schema_id: number;
  schema_name: string;
  schema_description: string;
  is_discreet: number;
  is_active: number;
  last_change?: Date | string;

  id_worst_grade_value: number;

  id_best_grade_value: number;

  id_min_grade_value_passed: number;

  worst_grade_value?: Grade; // this value has to be queried separately
  best_grade_value?: Grade; // this value has to be queried separately
  min_grade_value_passed?: Grade; // this value has to be queried separately
}

export interface GradeValue {
  grade_value_id: number;
  id_grade_schema: number;
  value: string;
  percentage: number;
  last_change?: Date | string | undefined;
  is_active?: number;
}

export interface Grade {
  grade_id?: number;
  id_grade_type?: GradeTypeCT;
  id_apprentice: number;
  value?: string;
  id_grade_schema: number;
  id_document_status: number;
  created_on?: Date | string | undefined;
  last_change?: Date | string | undefined;
  weight_in_grade_container?: number;
  counts_for_calculation?: number;
  is_approved?: number;
  is_active?: number;
  insert?: boolean;
  delete?: boolean;
}

export interface GradeContainer {
  grade_container_id?: number;
  id_rounding_type?: number;
  grade_value_type?: string;
  grade_value?: string | null;
  grade_value_percent?: number;
  grades: Grade[];
  id_grade_value_manual?: number | null;
  is_active?: number;
  last_change?: Date | string | undefined;
}

export interface ModuleGrade {
  id_grade_container: number;
  id_grade_schema?: number | null;
  grade_container: GradeContainer;
  grade_value?: string | null;
}

export interface ApprenticeModuleGrade {
  apprentice_module_grade_id: number;
  id_apprenticeship_module: number;
  module_grade: ModuleGrade;
  semester: number;
  id_apprentice: number;
  grade_date?: Date | string | undefined;
  last_change?: Date | string | undefined;
  is_active?: number;
}

export enum TimelineEnum {
  'past' = 0,
  'present' = 1,
  'future' = 2,
  'all_time' = 3,
}

export interface ApprenticeModuleGradeView extends ApprenticeModuleGrade {
  apprentice: Apprentice;
  timeline_status: TimelineEnum;
}